import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { changeOrderWarehouse } from '../../../actions/hdActions';
import { getUserPreference } from "../../../utilities/common";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { CircularProgress } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { useToken } from '../../../utilities/hooks';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: "100%"
        }
    },
    rowTitle: {
        fontSize: "1.2rem",
        backgroundColor: "#303030"
    },
    rowRightBorder: {
        borderLeft: "1px solid #5F5F5F"
    },
    rowContent: {
        marginTop: 10,
        backgroundColor: "rgba(255, 255, 255, 0.08)"
    },
    selectStyle: {
        marginLeft: 8
    },
    buttonStyle: {
        marginLeft: 20
    }
}));

const RESET_STATE = 301;
const BATCH_RESET_STATE = 313;
const BATCH_CHANGE_WAREHOUSE = 314;

function ChangeOrderWarehouse(branches) {
    const classes = useStyles();
    const { t } = useTranslation('helpDesk');
    const dispatch = useDispatch();

    let userPref = getUserPreference();
    const tokenContents = useToken();

    const userHasResetState = tokenContents.uiAbilities.includes(RESET_STATE);
    const userHasBatchResetState = tokenContents.uiAbilities.includes(BATCH_RESET_STATE);
    const userHasBatchChangeWarehouse = tokenContents.uiAbilities.includes(BATCH_CHANGE_WAREHOUSE);

    const [resetTnos, setResetTnos] = useState('');
    const [resetWarehouse, setResetWarehouse] = useState(1);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);

    const handleResetTnosInput = (event) => {
        setResetTnos(event.target.value);
    };

    const handleResetWarehouseInput = (event) => {
        setResetWarehouse(event.target.value);
    }

    function handleChangeOrderWarehouse() {
        let newTnos = resetTnos.split('\n');
        const tnoRegex = /^[\w\d]+$/i;
        const isValidTno = (tno) => tnoRegex.test(tno);

        if (!newTnos.every(isValidTno)) {
            dispatch(showAlertSnackbar({ message: t('format_fail_message'), type: 'error' }));
            return;
        }

        const tnosCurr = newTnos.join(',').replace(/\s/g, "");
        const userId = userPref.userId;

        setLoading(true);
        setDisable(true);

        dispatch(changeOrderWarehouse(tnosCurr, resetWarehouse, userId))
            .then((res) => {
                dispatch(showAlertSnackbar({ message: t('change_warehouse_success'), type: 'success' }));
            })
            .catch(() => {
                dispatch(showAlertSnackbar({ message: t('reset_fail_message'), type: 'error' }));
            })
            .finally(() => {
                setLoading(false);
                setDisable(false);
            })
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid container item xs={12} spacing={3} className={classes.rowTitle}>
                    <Grid item xs={3}>
                        {t('change_warehouse')}
                    </Grid>
                    <Grid item xs={9} className={classes.rowRightBorder}>
                        {t('only_station_manager')}
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    spacing={3}
                    alignItems="center"
                    justify="center"
                    className={classes.rowContent}
                >
                    <Grid item xs={3}>
                        TNO
                    </Grid>
                    <Grid item xs={9} className={classes.rowRightBorder}>
                        <TextField
                            id='helpdesk_changeorderwarehouse_textfield'
                            placeholder={t('input_placeholder')}
                            onChange={handleResetTnosInput}
                            multiline={userHasBatchResetState}
                            rows={userHasBatchResetState ? 10 : 1}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    spacing={3}
                    alignItems="center"
                    justify="center"
                    className={classes.rowContent}
                >
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    spacing={3}
                    alignItems="center"
                    justify="center"
                    className={classes.rowContent}
                >
                    <Grid item xs={3}>
                        {t('warehouse')}
                    </Grid>
                    <Grid item xs={9} className={classes.rowRightBorder}>
                        <Select
                            className={classes.selectStyle}
                            labelId="upload-warehouse-label"
                            id="upload-warehouse-select"
                            defaultValue={`1`}
                            displayEmpty
                            onChange={handleResetWarehouseInput}
                        >
                            {
                                (branches.branches).map((branch, index) => {
                                    return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    spacing={3}
                    style={{
                        marginTop: 10,
                    }}
                >
                    <Grid item xs={3}>
                    </Grid>
                    <Grid item xs={9} style={{ display: 'flex' }}>
                        <Button
                            id="helpdesk_changeorderwarehouse_button"
                            variant="contained"
                            color="primary"
                            style={{ width: "100%" }}
                            onClick={handleChangeOrderWarehouse}
                            disabled={!userHasBatchChangeWarehouse || disable}
                        >
                            {t('change')}
                        </Button>
                        {
                            loading &&
                            <div className={classes.buttonStyle}>
                                <CircularProgress color='secondary' />
                            </div>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

export default ChangeOrderWarehouse;
